import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import {
  InsuranceListPayload,
  InsuranceListResponse,
} from '@old/services/integration/insurance/insurance-list.type';
import { transformIntoQueryParamString } from '@old/utils/service';

// deprecated service ref.: getSilobagInsurance_DEPRECATED
export async function silobagInsuranceListService({ query: rawQuery }: InsuranceListPayload) {
  const query = transformIntoQueryParamString(rawQuery);
  const { response, data } = await BACKEND.get<InsuranceListResponse>(ENDPOINT.SILO_INSURANCE, { query });

  return {
    response,
    summary: data,
  };
}
